import { axios } from '@/utils/http'
import {
  SpringExamUser,
  SpringExamUserList
} from '@/models/springexam/SpringExam'
import { UploadResult } from '@/models/exam'
import { UploadFunc } from '@/models/exam'
import { post as upload } from '@/api/exam/upload'
import { HttpRequestOptions } from 'element-ui/types/upload'
import { createProcessHandler } from '@/utils/upload'
import { alert, notify } from '@/utils/notification'
/**
 * 获取列表
 * @param url apiurl
 */
export async function getList(examId: string, limit: number, offset: number) {
  const { data } = await axios.get(
    `SpringExam/${examId}/SpringExamUser?limit=${limit}&offset=${offset}&key=Name`
  )
  const result = data as SpringExamUserList
  return result
}

export async function postUsers(
  id: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  return await upload(
    `SpringExam/${id}/SpringExamUser/xls`,
    file,
    onUploadProgress
  )
}

const curryUpload = (upload: UploadFunc) => (id: string) => async (
  option: HttpRequestOptions
) => {
  try {
    const { count } = await upload(
      id,
      option.file,
      createProcessHandler(option)
    )
    notify(`上传成功, 共${count}条数据`)
    return true
  } catch (e) {
    notify('上传失败', e)
    return false
  }
}
export const uploadUsers = curryUpload(postUsers)

/**
 * 获取某一model
 * @param url url
 * @param id id
 */
export async function getbybmh(bmh: string, examId: string) {
  const { data } = await axios.get(
    `SpringExam/${examId}/SpringExamUser/bmhGet/${bmh}`
  )
  return data as SpringExamUser
}

/**
 * 获取某一model
 * @param url url
 * @param id id
 */
export async function get(id: string, examId: string) {
  const { data } = await axios.get(`SpringExam/${examId}/SpringExamUser/${id}`)
  return data as SpringExamUser
}

/**
 * 创建某一model
 * @param url url
 * @param model id
 */
export async function post(model: SpringExamUser, examId: string) {
  const { data } = await axios.post(
    `SpringExam/${examId}/SpringExamUser`,
    model
  )
  return data as SpringExamUser
}

/**
 * 修改某一model
 * @param url url
 * @param id id
 * @param model id
 */
export async function put(id: string, model: SpringExamUser, examId: string) {
  await axios.put(`SpringExam/${examId}/SpringExamUser/${id}`, model)
}

/**
 * 删除某一model
 * @param url url
 * @param id id
 * @param model id
 */
export async function del(id: string, examId: string) {
  await axios.delete(`SpringExam/${examId}/SpringExamUser/${id}`)
}

/**
 * 删除某一考试全部学生
 * @param url url
 * @param model id
 */
export async function delAll(examId: string) {
  await axios.delete(`SpringExam/${examId}/SpringExamUser`)
}
